export const defaultColumns = [
  {
    name: 'number',
    active: true,
    title: 'MAINTENANCES.HEADER.NUMBER',
  },
  {
    name: 'location',
    active: true,
    title: 'MAINTENANCES.HEADER.LOCATION',
  },
  {
    name: 'type',
    active: true,
    title: 'MAINTENANCES.HEADER.TYPE',
  },
  {
    name: 'pendencies',
    active: false,
    title: 'MAINTENANCES.HEADER.PENDENCIES',
  },
  {
    name: 'segment',
    active: true,
    title: 'MAINTENANCES.HEADER.SEGMENT',
  },
  {
    name: 'paymentNumber',
    active: true,
    title: 'MAINTENANCES.HEADER.PAYMENT_NUMBER',
  },
  {
    name: 'paymentStatus',
    active: true,
    title: 'MAINTENANCES.HEADER.PAYMENT_STATUS',
  },
  {
    name: 'message',
    active: false,
    title: 'MAINTENANCES.HEADER.MESSAGE',
  },
  {
    name: 'status',
    active: true,
    title: 'MAINTENANCES.HEADER.STATUS',
  },
  {
    name: 'totalValue',
    active: true,
    title: 'MAINTENANCES.HEADER.VALUE',
  },
  {
    name: 'responseDeadlineStatus',
    active: false,
    title: 'MAINTENANCES.HEADER.RESPONSE_DEADLINE',
  },
  {
    name: 'solutionDeadlineStatus',
    active: false,
    title: 'MAINTENANCES.HEADER.SOLUTION_DEADLINE',
  },
  {
    name: 'stars',
    active: true,
    title: 'MAINTENANCES.HEADER.AVERAGE_RATINGS',
  },
  {
    name: 'company',
    active: true,
    title: 'MAINTENANCES.HEADER.COMPANY',
  },
  {
    name: 'openedAt',
    active: true,
    title: 'MAINTENANCES.HEADER.OPENED_AT',
  },
  {
    name: 'updatedAt',
    active: true,
    title: 'MAINTENANCES.HEADER.UPDATED_AT',
  },
  {
    name: 'closedAt',
    active: true,
    title: 'MAINTENANCES.HEADER.DONE_AT',
  },
  {
    name: 'scheduledAt',
    active: false,
    title: 'MAINTENANCES.HEADER.SCHEDULED_AT',
  },
  {
    name: 'scheduledTime',
    active: false,
    title: 'MAINTENANCES.HEADER.SCHEDULED_TIME',
  },
  {
    name: 'duration',
    active: true,
    title: 'MAINTENANCES.HEADER.DURATION',
  },
  {
    name: 'visitCount',
    active: false,
    title: 'MAINTENANCES.HEADER.VISITS',
  },
  {
    name: 'statusDescription',
    active: false,
    title: 'MAINTENANCES.HEADER.STATUS_DESCRIPTION',
  },
  {
    name: 'warrantySummaryStatus',
    active: false,
    title: 'MAINTENANCES.HEADER.WARRANTY_SUMMARY_STATUS',
    flag: 'warranties'
  },
  {
    name: 'linkedWarranties',
    active: false,
    title: 'MAINTENANCES.HEADER.LINKED_WARRANTIES',
    flag: 'warranties'
  },
  {
    name: 'warrantyStartDate',
    active: false,
    title: 'MAINTENANCES.HEADER.WARRANTY_START_DATE',
    flag: 'warranties'
  },
  {
    name: 'warrantyEndDate',
    active: false,
    title: 'MAINTENANCES.HEADER.WARRANTY_END_DATE',
    flag: 'warranties'
  },
  {
    name: 'weight',
    active: false,
    title: 'MAINTENANCES.HEADER.WEIGHT',
    flag: 'weight'
  },
  {
    name: 'edit',
    active: true,
    title: 'MAINTENANCES.HEADER.EDIT',
  }
];
